import { Component, OnInit } from '@angular/core';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { RulesTurnsService } from 'src/app/services/turns-services/rules-turns-service/rules-turns.service';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-turns-rules-dashboard',
  templateUrl: './turns-rules-dashboard.component.html',
  styleUrls: ['./turns-rules-dashboard.component.scss']
})
export class TurnsRulesDashboardComponent implements OnInit {

  actions;

  constructor(private rulesTurnsService: RulesTurnsService,
    private headerBreadcrumbService: HeaderBreadcrumbService) {
  }

  ngOnInit() {
    this.getRuleActions();
    this.setBreadcrumb();
  }

  private getRuleActions() {
    this.rulesTurnsService.getRuleActions().pipe(
      tap(o => this.actions = o['actions']),
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('', 'turns-page.rules', '/turns/parameters', [new BRoute('turns-page.turns', '/turns'), new BRoute('turns-page.parameters', '/turns/parameters'), new BRoute('turns-page.rules')]));
  }

}
